<template>
    <Sheet class="container">
        <span class="error hidden-sm-and-down">ERROR!</span>
        <span class="error sm hidden-md-and-up">ERROR!</span>
        <h1>500</h1>
        <h3>系統發生錯誤!!</h3>
        <div>
            請按此
            <el-button
                    type="success"
                    style="margin: 0 2px;"
                    @click="onReturn"
            >
                回首頁
            </el-button>
            返回首頁
        </div>
    </Sheet>
</template>

<script>
    import ExceptionMixin from './ExceptionMixin';

    export default {
        name: 'Error',
        mixins:[ExceptionMixin],
    }
</script>

<style scoped>
    .container{
        text-align: center;
    }
    .container .error{
        font-size: 4rem;
        font-weight: bolder;
        color: red;
    }
    .container .error.sm{
        font-size: 2rem;
    }
</style>